/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  DiscountFeeder,
  DiscountFeederInterface,
} from "../../contracts/DiscountFeeder";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IStakingTierManager",
        name: "_stakingTierManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "percentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "oneHundredPercent",
        type: "uint256",
      },
    ],
    name: "DiscountFeeder_PercentageTooLarge",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "DiscountFeeder_TierNotDefined",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "DiscountRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "discount",
        type: "uint256",
      },
    ],
    name: "DiscountSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getDiscount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "removeDiscount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "discount",
        type: "uint256",
      },
    ],
    name: "setDiscount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IStakingTierManager",
        name: "_stakingTierManager",
        type: "address",
      },
    ],
    name: "setStakingTierManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingTierManager",
    outputs: [
      {
        internalType: "contract IStakingTierManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierToDiscount",
    outputs: [
      {
        internalType: "bool",
        name: "defined",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "discount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type DiscountFeederConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DiscountFeederConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DiscountFeeder__factory extends ContractFactory {
  constructor(...args: DiscountFeederConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _stakingTierManager: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _stakingTierManager,
      owner_,
      overrides || {}
    );
  }
  override deploy(
    _stakingTierManager: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _stakingTierManager,
      owner_,
      overrides || {}
    ) as Promise<
      DiscountFeeder & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): DiscountFeeder__factory {
    return super.connect(runner) as DiscountFeeder__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DiscountFeederInterface {
    return new Interface(_abi) as DiscountFeederInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): DiscountFeeder {
    return new Contract(address, _abi, runner) as unknown as DiscountFeeder;
  }
}
